// The service worker keeps API responses for offline use (see service-worker.js, "api-cache-v1").
// Clear them whenever the signed-in user changes so the next person on a shared device
// never sees the previous user's data.
export async function clearCachedApiData() {
  try {
    if (typeof caches !== 'undefined') {
      await caches.delete('api-cache-v1');
    }
  } catch {
    // Cache storage can be unavailable (private mode, old browsers); nothing to clear then.
  }
}
